import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { CashWorkflowSnapshotV1 } from '@pokerroom/types';
import { api } from '../../../lib/api';
import { CashComparison } from './CashComparison';

export function CurrentCashComparison({
  sessionId,
  venue,
  scope,
}: {
  sessionId: string;
  venue: string;
  scope: string;
}) {
  const { t } = useTranslation('accounting');
  const query = useQuery({
    queryKey: ['accounting-current-cash-comparison', scope, sessionId],
    queryFn: ({ signal }) =>
      api.get<CashWorkflowSnapshotV1>(
        `/accounting/cash-workflow/${encodeURIComponent(sessionId)}`,
        { signal },
      ),
    staleTime: 0,
    refetchOnMount: 'always',
    retry: false,
  });
  if (query.isFetching) return <p role="status">{t('cashSummaryLoading')}</p>;
  if (
    query.isError ||
    !query.data ||
    query.data.venueId !== venue ||
    query.data.sessionId !== sessionId ||
    query.data.status !== 'OPEN'
  )
    return (
      <p role="alert">
        {t('cashWorkflow.loadFailed')}{' '}
        <button type="button" onClick={() => void query.refetch()}>
          {t('cashWorkflow.refresh')}
        </button>
      </p>
    );
  return <CashComparison snapshot={query.data} />;
}
